import styled from 'styled-components';

const NoWrap = styled.span`
    white-space: nowrap;
`;
export default NoWrap;
